export default "__VITE_ASSET__CWDZS2FU__"